import { FC } from 'react';
import { Box, Button, Paper, Typography } from '@material-ui/core';
import LockIcon from '@material-ui/icons/Lock';
import { UPGRADE_PAGE_PATH } from './limit-message-with-upgrade';

interface PremiumReviewLockProps {
  reviewNumber: number;
}

/**
 * Shown in place of a Review screen when a non-premium user opens a review that
 * is gated behind a premium subscription (free tier is limited to Review 1).
 */
export const PremiumReviewLock: FC<PremiumReviewLockProps> = ({ reviewNumber }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: 'calc(100vh - 64px)',
      p: 3,
      backgroundColor: 'background.default'
    }}
  >
    <Paper
      variant="outlined"
      sx={{ p: 4, maxWidth: 480, textAlign: 'center', borderRadius: 2 }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          backgroundColor: 'primary.main',
          color: 'primary.contrastText',
          display: 'grid',
          placeItems: 'center',
          mx: 'auto',
          mb: 2
        }}
      >
        <LockIcon />
      </Box>
      <Typography variant="h6" gutterBottom>
        Review {reviewNumber} — fonctionnalité Premium
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
        L'offre gratuite donne accès à la Review 1. Passez à un abonnement premium
        pour débloquer les Reviews 2, 3 et 4 et exploiter toute la méthode IpOp.
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          window.location.href = UPGRADE_PAGE_PATH;
        }}
      >
        Passer à Premium
      </Button>
    </Paper>
  </Box>
);
